export function style() {
}

style.prototype.set = function (name, value) {
    document.documentElement.style.setProperty(
        name,
        value
    );
}